<!-- No facility bar: these figures span every facility the user is associated with, so naming the
     one selected in the header would misdescribe them. Each row names its own facility instead. -->
<pcg-resizable-widget>
    <span widget-title>Insulin Forms Requiring Review</span>

    <!-- The count rides in the header so it is readable without scrolling the body, which is the
         whole point of a widget somebody glances at. -->
    <div widget-meta>
        @if (isEnabled()) {
            <p-tag
                [value]="count().toString()"
                severity="warn"
                [attr.aria-label]="count() + ' applications waiting on a reviewer'"
            />
        }
    </div>

    <!-- A flex column exactly as tall as the slot it sits in, so the rows scroll inside it and the
         action below stays put. Sized to 100% rather than left to grow, which also means the shell's
         own overflow never triggers - there is only ever one scrollbar, on the rows. -->
    <div class="insulin-body" widget-body>
        @if (isLoading()) {
            <div class="mt-2 pb-1 text-center" aria-live="polite">
                <span class="spinner-border spinner-border-sm align-middle mr-1" aria-hidden="true"></span>
                Loading Insulin review work...
            </div>
        } @else if (hasError()) {
            <!-- Said out loud rather than shown as zero. A zero here reads as "nothing to do", which
                 is the one wrong thing to tell somebody whose figures failed to load. -->
            <div class="insulin-widget-state text-danger" role="alert">
                <i class="pi pi-exclamation-triangle mr-1" aria-hidden="true"></i>
                These figures could not be loaded. Refresh to try again.
            </div>
        } @else if (!isEnabled()) {
            <div class="insulin-widget-state">
                {{ unavailableMessage() }}
            </div>
        } @else {
            <!-- The only thing that scrolls. Every application waiting on a reviewer is here, so the
                 list can be long - which is why the action below is pinned rather than chased. -->
            <div class="insulin-rows">
            @for (row of rows(); track row.bcdProgramApplicationId) {
                <pcg-link [href]="reviewUrl(row.bcdProgramApplicationId)" [hideStyling]="true">
                    <div class="insulin-row">
                        <!-- Decorative: the chip on the right says the same thing in words. -->
                        <span class="insulin-dot" data-severity="warn" aria-hidden="true"></span>

                        <div class="insulin-row-main">
                            <div class="insulin-row-name" data-dd-privacy="mask">{{ row.applicantName }}</div>
                            <div class="insulin-row-meta">
                                {{ row.facilityName }} &middot; submitted {{ row.ageInDays }}d ago
                            </div>
                        </div>

                        <!-- The same p-tag the queue, the review screen and the status page use for
                             a status, so this chip cannot end up a different colour from them. -->
                        <p-tag
                            [value]="statusLabel(reviewStatus)"
                            [severity]="statusSeverity(reviewStatus)"
                        />
                    </div>
                </pcg-link>
            } @empty {
                <div class="insulin-widget-state">Nothing is waiting on a reviewer right now.</div>
            }
            </div>

            <!-- The list is capped, so it says what it is not showing rather than letting the count
                 above and the rows below silently disagree. -->
            @if (count() > rows().length) {
                <div class="insulin-widget-more">
                    Showing the {{ rows().length }} oldest of {{ count() }}.
                </div>
            }

            <div class="insulin-widget-footer">
                <pcg-link [href]="queueUrl()">Open intake queue</pcg-link>
            </div>
        }
    </div>
</pcg-resizable-widget>
